import { FmlxSlider } from 'fmlx-common-ui';
import React from 'react';

const Slider = ({ min = 0, max = 10, value, onChange }) => {
  return (
    <div
      id="controls-slider-wrapper"
      data-testid="controls-slider-wrapper"
      className="flex flex-row items-center w-full p-4 gap-4"
    >
      <span
        id={`controls-slider-${min}`}
        data-testid={`controls-slider-${min}`}
        className="text-md font-medium"
      >
        {min}
      </span>
      <div
        id={`controls-slider-${value}`}
        data-testid={`controls-slider-${value}`}
        className="w-full"
      >
        <FmlxSlider
          id={`controls-slider-${value}`}
          label=""
          decoration="none"
          onChange={onChange}
          value={value}
          minValue={min}
          maxValue={max}
        />
      </div>
      <span
        id={`controls-slider-${max}`}
        data-testid={`controls-slider-${max}`}
        className="text-md font-medium"
      >
        {max}
      </span>
    </div>
  );
};

export default Slider;
